import { template as template_9fce0530012f45afb420f3ee1fc291a4 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import Portal from 'ember-stargate/components/portal';
import SearchTag from 'eflex/components/filters/search-tag';
import FilterWrapper from 'eflex/components/filters/filter-wrapper';
import { t } from 'ember-intl';
import { findBy } from '@eflexsystems/ember-composable-helpers';
export default class BiPanelProcessDataSearch extends Component {
    @service
    intl;
    @tracked
    isDisplayed = false;
    @tracked
    isNumericSearch = false;
    radioOptions = [
        {
            label: 'stringSearch',
            value: false
        },
        {
            label: 'numericSearch',
            value: true
        }
    ];
    constructor(){
        super(...arguments);
        this.isDisplayed = Boolean(this.args.searchTerm);
        this.isNumericSearch = this.args.isNumericSearch;
        this.args.initParam('isNumericSearch', this.args.isNumericSearch);
        this.args.initParam('searchTerm', this.args.searchTerm);
    }
    @action
    changeSearchTerm(searchTerm) {
        this.args.updateParam('searchTerm', searchTerm);
    }
    @action
    changeIsNumericSearch(isNumericSearch) {
        this.isNumericSearch = isNumericSearch.value;
        this.args.updateParam('isNumericSearch', isNumericSearch.value);
    }
    get selectedVariablesBadgeText() {
        return `${this.intl.t('processDataSearch')}: ${this.args.searchTerm}`;
    }
    onDisplayedChanged = ()=>{
        this.isDisplayed = !this.isDisplayed;
    };
    static{
        template_9fce0530012f45afb420f3ee1fc291a4(`
    <Portal @target="filter-fields">
      <FilterWrapper
        class="eflex-process-data-search-criteria"
        @class="align-items-end"
        @form={{@form}}
        @label="processData"
        @isDisplayed={{this.isDisplayed}}
        @onChecked={{this.onDisplayedChanged}}
        @hasValue={{@searchTerm}}
        ...attributes
      >
        <div class="input-group">
          <div class="col">
            <div class="row">
              <div class="col">
                <@form.element
                  class="mb-3"
                  @controlType={{if this.isNumericSearch 'number' 'text'}}
                  @value={{@searchTerm}}
                  @onChange={{this.changeSearchTerm}}
                />

                <@form.element
                 @controlType="radio-group"
                 @options={{this.radioOptions}}
                 @value={{findBy 'value' this.isNumericSearch this.radioOptions}}
                 @onChange={{this.changeIsNumericSearch}}
                as |el|>
                  <el.control @inline={{true}} as |opt|>
                    {{t opt.label}}
                  </el.control>
                </@form.element>
              </div>
            </div>
          </div>
        </div>
      </FilterWrapper>
    </Portal>

    <Portal @target="search-badge-tags">
      <SearchTag
        @isDisplayed={{@searchTerm}}
        @text={{this.selectedVariablesBadgeText}}
      />
    </Portal>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
